import React, { useState, useEffect } from "react";
import { postData } from "../../../../utility/Utility";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomLoader from "../../../../Components/CustomLoader/CustomLoader";
import ReactPaginate from "react-paginate";

export default function RewardPointsList() {
  const [loading, setLoading] = useState(false);
  const [rewardPoints, setRewardPoints] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [searchUsername, setSearchUsername] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const rowsPerPage = 10;

  const fetchRewardPoints = async (page = 1, username = "") => {
    setLoading(true);
    try {
      const params = {
        page,
        limit: rowsPerPage,
       search: username,
      };

      // Only add dates if they have values
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;

      const response = await postData(
        "api/reward-points/allow-policy-points",
        params
      );

      if (response?.success) {
        setRewardPoints(response.data);
      } else {
        toast.error(response?.message || "Failed to fetch reward points");
      }
    } catch (error) {
      console.error("Error fetching reward points:", error);
      toast.error("Failed to fetch reward points");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(0);
    fetchRewardPoints(1, searchUsername);
  };

  const handleReset = () => {
    setSearchUsername("");
    setStartDate("");
    setEndDate("");
    setCurrentPage(0);
    fetchRewardPoints(1, "", "", "");
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchRewardPoints(currentPage + 1, searchUsername);
    }, 500);
    return () => clearTimeout(timer);
  }, [startDate, endDate, currentPage, searchUsername]);

  useEffect(() => {
    fetchRewardPoints(currentPage + 1, searchUsername);
  }, [currentPage]);

  return (
    <div className="content-page">
      <CustomLoader loading={loading} />
      <div className="content">
        <div className="container-fluid">
          <div className="py-3">
            <h4 className="fs-18 fw-semibold m-0">Policy Reward List</h4>
            <p className="fw-semibold my-2">
              View and manage policy reward points
            </p>
          </div>

          {/* Search Section */}
          <div className="card mb-3">
            <div className="card-body">
              <form onSubmit={handleSearch}>
                <div className="row">
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search username"
                      value={searchUsername}
                      onChange={(e) => setSearchUsername(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <input
                      type="date"
                      className="form-control"
                      placeholder="Start date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <input
                      type="date"
                      className="form-control"
                      placeholder="End date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <div className="d-flex">
                      <button
                        type="submit"
                        className="btn btn-primary me-2 flex-grow-1"
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* Reward Points Table */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                {rewardPoints?.users?.length > 0 ? (
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>User</th>
                        <th className="text-center">Points</th>
                        <th>Policy Summary</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rewardPoints.users.map((user, index) => (
                        <tr key={user.userId}>
                          <td>{currentPage * rowsPerPage + index + 1}</td>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="avatar-sm me-3">
                                <div className="avatar-title rounded-circle bg-light text-primary">
                                  {user.user.fullName
                                    ? user.user.fullName.charAt(0).toUpperCase()
                                    : user.user.email.charAt(0).toUpperCase()}
                                </div>
                              </div>
                              <div>
                                <h6 className="mb-0">
                                  {user.user.fullName || "No name provided"}
                                </h6>
                                <div className="text-muted">
                                  <small>{user.user.email}</small>
                                </div>
                                <div className="text-muted">
                                  <small>{user.user.mobile}</small>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="text-center">
                            <span className="badge bg-success p-2">
                              {user.totalPoints} pts
                            </span>
                          </td>
                          <td>
                            {user.policyDetails.map((policy) => (
                              <div key={policy._id} className="mb-3">
                                <div className="row">
                                  <div className="col-md-4">
                                    <div className="fw-bold">Policy Info</div>
                                    <div>#{policy.policyNumber}</div>
                                    <div>{policy.insurance_plan}</div>
                                    <div className="badge bg-success">
                                      {policy.status}
                                    </div>
                                  </div>
                                  <div className="col-md-4">
                                    <div className="fw-bold">Vehicle</div>
                                    <div>{policy.vehicleModel}</div>
                                    <div>{policy.vehicleNumber}</div>
                                    <div>
                                      IDV: ₹{policy.IDV?.toLocaleString()}
                                    </div>
                                  </div>
                                  <div className="col-md-4">
                                    <div className="fw-bold">
                                      Dates & Amount
                                    </div>
                                    <div>
                                      {new Date(
                                        policy.policyStartDate
                                      ).toLocaleDateString()}{" "}
                                      -{" "}
                                      {new Date(
                                        policy.policyEndDate
                                      ).toLocaleDateString()}
                                    </div>
                                    <div>
                                      Amount: ₹
                                      {policy.sale_amount?.toLocaleString()}
                                    </div>
                                    <div>
                                      Points:{" "}
                                      {Math.round(policy.sale_amount / 10)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="text-center p-3">
                    No reward points data found
                  </div>
                )}
              </div>

              {/* Pagination */}
              {rewardPoints?.pagination && (
                <div className="d-flex justify-content-end">
                  <ReactPaginate
                    previousLabel="Previous"
                    nextLabel="Next"
                    pageCount={rewardPoints.pagination.pages}
                    onPageChange={handlePageChange}
                    containerClassName="pagination"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                    breakLabel="..."
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
